import api from './base-api';
import { SendEmailDto, SendWaitlistNotifyDto } from '@sportspredict/shared';

const emailsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		sendEmail: builder.mutation<void, SendEmailDto>({
			query: (body) => ({ url: 'emails/send', method: 'POST', body }),
		}),

		sendWaitlistNotify: builder.mutation<{ success: true }, SendWaitlistNotifyDto>({
			query: (body) => ({ url: 'emails/send-waitlist-notify', method: 'POST', body }),
		}),
	}),
	overrideExisting: false,
});

export const { useSendEmailMutation, useSendWaitlistNotifyMutation } = emailsApi;
